import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import CloseButton from '../../common/CloseButton/CloseButton';
import '../../common/CommonText.css'
import './MyProfile.css';
import { showLogoutConfirmation } from './logoutalert';


const MyProfile = ({ isOpen, onClose }) => {
    const popupRef = useRef(null);
    const navigate = useNavigate();
    
    const handleLogout = () => {
        showLogoutConfirmation("Are you sure you want to logout?", () => {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('bearer');
          localStorage.removeItem('authToken');
          localStorage.removeItem('lastVisitedRoute');
          onClose();
          navigate('/login');
        });
      };
      
    
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
          onClose();
        }
      };
      
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [onClose]);
    
    if (!isOpen) return null;
    
    const handlePersonalDetailClick = () => {
      navigate(`/personal-profile/`);
    };
    
    return (
      <div className="my-profile-popup-overlay">
        <div className="myprofile-popup-container" ref={popupRef}>
          <div className='myprofile-popup'>
            <button className='my-profile-option' onClick={handlePersonalDetailClick}>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5 4C5 2.93913 5.42143 1.92172 6.17157 1.17157C6.92172 0.421427 7.93913 0 9 0C10.0609 0 11.0783 0.421427 11.8284 1.17157C12.5786 1.92172 13 2.93913 13 4C13 5.06087 12.5786 6.07828 11.8284 6.82843C11.0783 7.57857 10.0609 8 9 8C7.93913 8 6.92172 7.57857 6.17157 6.82843C5.42143 6.07828 5 5.06087 5 4ZM5 10C3.67392 10 2.40215 10.5268 1.46447 11.4645C0.526784 12.4021 0 13.6739 0 15C0 15.7956 0.316071 16.5587 0.87868 17.1213C1.44129 17.6839 2.20435 18 3 18H15C15.7956 18 16.5587 17.6839 17.1213 17.1213C17.6839 16.5587 18 15.7956 18 15C18 13.6739 17.4732 12.4021 16.5355 11.4645C15.5979 10.5268 14.3261 10 13 10H5Z" fill="#424242"/>

              </svg>
              <span className='common-text fts-15 lt-gray ftw-4'>My Profile</span>
            </button>
            <button className='my-profile-option my-profile-option-logout' onClick={handleLogout}>
              <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                         <path d="M0.9 18C0.661305 18 0.432387 17.9052 0.263604 17.7364C0.0948213 17.5676 0 17.3387 0 17.1V0.9C0 0.661305 0.0948213 0.432387 0.263604 0.263604C0.432387 0.0948211 0.661305 0 0.9 0H13.5C13.7387 0 13.9676 0.0948211 14.1364 0.263604C14.3052 0.432387 14.4 0.661305 14.4 0.9V17.1C14.4 17.3387 14.3052 17.5676 14.1364 17.7364C13.9676 17.9052 13.7387 18 13.5 18H0.9ZM9.9 12.6L14.4 9L9.9 5.4V8.1H4.5V9.9H9.9V12.6Z" fill="#424242"/>

              </svg>
              <span className='common-text fts-15 lt-gray ftw-4'>Log Out</span>
            </button>
          </div>
        </div>
      </div>
    );
  };
  
  MyProfile.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
  };
  
  export default MyProfile;
  